import Vue from 'vue';
import '@/app/assets/calculators-styles.css';
import App from './App.vue';
import { RegionSelect, SymbolSelect } from '@/ui-components';
import { CarCalculator } from '@/calculators';

Vue.config.productionTip = false;

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.eventSetDrag = function () {
      el.setAttribute('data-dragging', 'yes');
    };
    el.eventClearDrag = function () {
      el.removeAttribute('data-dragging');
    };
    el.eventOnClick = function (event) {
        const dragging = el.getAttribute('data-dragging');
        if (!(el == event.target || el.contains(event.target)) && !dragging) {
          vnode.context[binding.expression](event);
        }
    };
    document.addEventListener('touchstart', el.eventClearDrag);
    document.addEventListener('touchmove', el.eventSetDrag);
    document.addEventListener('click', el.eventOnClick);
    document.addEventListener('touchend', el.eventOnClick);
  },
  unbind: function (el) {
    document.removeEventListener('touchstart', el.eventClearDrag);
    document.removeEventListener('touchmove', el.eventSetDrag);
    document.removeEventListener('click', el.eventOnClick);
    document.removeEventListener('touchend', el.eventOnClick);
    el.removeAttribute('data-dragging');
  },
});

Vue.component('RegionSelect', RegionSelect);
Vue.component('SymbolSelect', SymbolSelect);
Vue.component('CarCalculator', CarCalculator);

new Vue({
  render: h => h(App),
}).$mount('#app');
